import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import { useTheme } from "../../context/ThemeContext";

/**
 * Per-strategy hint card — shows the selected ring-group strategy's icon and
 * description with a colored left rule + tinted icon swatch. The strategy
 * defines its own `icon` (MaterialCommunity name), `tone` (theme color key),
 * and `description` (the user-facing explanation).
 */
function NtStrategyHint({ strategy, containerStyle }) {
  const { theme } = useTheme();
  const accent = theme[strategy?.tone] || theme.brand2;
  const styles = useMemo(() => makeStyles(theme, accent), [theme, accent]);

  if (!strategy?.description) return null;

  return (
    <View style={[styles.wrap, containerStyle]}>
      {strategy.icon ? (
        <View style={styles.iconBox}>
          <NtMaterialIcon name={strategy.icon} color={accent} size={14} />
        </View>
      ) : null}
      <View style={{ flex: 1, minWidth: 0 }}>
        <NtText style={styles.title}>{strategy.title}</NtText>
        <NtText style={styles.desc}>{strategy.description}</NtText>
      </View>
    </View>
  );
}

const makeStyles = (t, accent) =>
  StyleSheet.create({
    wrap: {
      flexDirection: "row",
      alignItems: "flex-start",
      gap: 10,
      paddingVertical: 8,
      paddingRight: 10,
      paddingLeft: 12,
      borderLeftWidth: 3,
      borderLeftColor: accent,
    },
    iconBox: {
      width: 26,
      height: 26,
      borderRadius: 5,
      backgroundColor: accent + "26",
      borderWidth: 1,
      borderColor: accent + "44",
      alignItems: "center",
      justifyContent: "center",
    },
    title: {
      color: accent,
      fontSize: 11,
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: 0.5,
      marginBottom: 2,
    },
    desc: {
      color: t.textDim,
      fontSize: 12,
      lineHeight: 17,
    },
  });

export default NtStrategyHint;
